enum PersonalPropertyLossAdjustmentBases {
	RCV = 'RCV',
	ACV = 'ACV',
}

export default PersonalPropertyLossAdjustmentBases;